/* THIS FILE IS GENERATED BY PermissionTypeScriptGenerator. */
export const PERMISSION_KEYS = {
  agentDiagnosticManage: 'agent.diagnostic.manage',
  agentDiagnosticRead: 'agent.diagnostic.read',
  agentInstallerRead: 'agent.installer.read',
  agentManage: 'agent.manage',
  agentPskManage: 'agent.psk.manage',
  agentRead: 'agent.read',
  agentReleaseRead: 'agent.release.read',
  agentRequiredpackageManage: 'agent.requiredpackage.manage',
  alertEmailManage: 'alert.email.manage',
  alertManage: 'alert.manage',
  alertRead: 'alert.read',
  assetEvidenceRead: 'asset.evidence.read',
  auditRead: 'audit.read',
  auditSensitiveRead: 'audit.sensitive.read',
  billingAccountManage: 'billing.account.manage',
  billingUsageRead: 'billing.usage.read',
  billingWrite: 'billing.write',
  capabilityEdit: 'capability.edit',
  capabilityRead: 'capability.read',
  classificationCatalogManage: 'classification.catalog.manage',
  classificationCatalogRead: 'classification.catalog.read',
  contentManage: 'content.manage',
  contentPublish: 'content.publish',
  contentRead: 'content.read',
  customfieldEdit: 'customfield.edit',
  customfieldManage: 'customfield.manage',
  customfieldRead: 'customfield.read',
  docsRead: 'docs.read',
  eautomateManage: 'eautomate.manage',
  eautomateRead: 'eautomate.read',
  hierarchyDelete: 'hierarchy.delete',
  hierarchyEdit: 'hierarchy.edit',
  hierarchyRead: 'hierarchy.read',
  iamManage: 'iam.manage',
  iamServiceaccountManage: 'iam.serviceaccount.manage',
  iamServiceaccountRead: 'iam.serviceaccount.read',
  integrationManage: 'integration.manage',
  integrationRead: 'integration.read',
  learningManage: 'learning.manage',
  learningRead: 'learning.read',
  notificationSend: 'notification.send',
  oauthApplicationManage: 'oauth.application.manage',
  oauthApplicationRead: 'oauth.application.read',
  printerPolicyManage: 'printer.policy.manage',
  reportAdminDelete: 'report.admin.delete',
  reportAdminEdit: 'report.admin.edit',
  reportAdminManage: 'report.admin.manage',
  reportAdminRead: 'report.admin.read',
  serviceaccountRatelimitManage: 'serviceaccount.ratelimit.manage',
  settingEdit: 'setting.edit',
  ssoManage: 'sso.manage',
  workflowManage: 'workflow.manage',
  workflowRead: 'workflow.read',
} as const

export type PermissionKey =
  (typeof PERMISSION_KEYS)[keyof typeof PERMISSION_KEYS]
